import {styled} from "@mui/material";

export const FieldTableTitleTooltip = styled('div', {
    name: 'FieldTable', slot: 'titleTooltip',
    shouldForwardProp: (prop) =>
        prop !== 'variant' && prop !== 'sx',
    overridesResolver: (props, styles) => [
        styles.titleTooltip
    ],
})({});
